export default "/static/frontend/images/images/07cb099b00426efd94e3e2e081ea02c3-google-play.png";